export enum MessageBoxButtons {
    None = 0,
    Ok = 1,
    OkCancel = 2,
    YesNo = 3,
    YesNoAbort = 4
}